import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
type CalendlyModalProps = {
  open: boolean;
  onClose: () => void;
};

/**
 * Terminbuchung als eigenes Modal mit eingebettetem Calendly-Kalender.
 * Farben sind an die Website angepasst (Creme, dunkler Text, Hot-Pink).
 */
const CALENDLY_URL = 'https://calendly.com/tinaxla/erstgesprach' + '?hide_gdpr_banner=1' + '&hide_landing_page_details=1' + '&background_color=fdf9f6' + '&text_color=262626' + '&primary_color=e93b8f';
export function CalendlyModal({
  open,
  onClose
}: CalendlyModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [open, onClose]);
  return <AnimatePresence data-id="element-180" data-mp="ygz641czqf1u">
      {open && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[70] flex items-center justify-center bg-neutral-900/60 p-3 backdrop-blur-sm sm:p-6" onClick={onClose} data-id="element-181" data-mp="yi0pct45u7un">
          <motion.div role="dialog" aria-modal="true" aria-label="Kostenloses Gespräch buchen" initial={{
        opacity: 0,
        scale: 0.96,
        y: 12
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.97,
        y: 8
      }} transition={{
        duration: 0.22,
        ease: 'easeOut'
      }} onClick={e => e.stopPropagation()} className="relative h-[85vh] w-full max-w-3xl overflow-hidden rounded-2xl bg-cream shadow-2xl" data-id="element-182" data-mp="1md3ivedwszhg">
            <button type="button" onPointerUp={e => {
          e.preventDefault();
          e.stopPropagation();
          onClose();
        }} onClick={e => {
          e.stopPropagation();
          onClose();
        }} aria-label="Schließen" className="absolute right-3 top-3 z-20 flex h-11 w-11 touch-manipulation items-center justify-center rounded-full bg-white text-neutral-700 shadow-md transition-colors duration-150 ease-out hover:bg-white hover:text-neutral-900" data-id="element-183" data-mp="204i3fpngt8qm">
              <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-184" data-mp="1qhlzqk2x5xzi" />
            </button>

            <iframe src={CALENDLY_URL} title="Terminbuchung – kostenloses Erstgespräch" className="h-full w-full border-0" loading="lazy" data-id="element-185" data-mp="1qfhqdmm946ru" />
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}